import type { InputManager } from './input-manager';
import type { Direction } from '../game/state';
export function bindKeyboard(input:InputManager,actions:{start:()=>void;pause:()=>void;music:()=>void}):()=>void{
  const directions:Record<string,Direction>={ArrowUp:'up',ArrowDown:'down',ArrowLeft:'left',ArrowRight:'right'};
  const keydown=(e:KeyboardEvent):void=>{
    if(e.target instanceof HTMLElement&&e.target.matches('input,select,textarea,button')){
      if(e.key==='Escape')actions.pause();return;
    }
    if(directions[e.key]){e.preventDefault();if(!e.repeat)input.press(`key-${e.key}`,directions[e.key]!);}
    else if(!e.repeat){
      if(e.key==='Enter'){e.preventDefault();actions.start();}
      if(e.key==='Escape'||e.key.toLowerCase()==='p'){e.preventDefault();actions.pause();}
      if(e.key.toLowerCase()==='m'){e.preventDefault();actions.music();}
    }
  };
  const keyup=(e:KeyboardEvent):void=>{if(directions[e.key]){e.preventDefault();input.release(`key-${e.key}`);}};
  document.addEventListener('keydown',keydown);document.addEventListener('keyup',keyup);
  return()=>{document.removeEventListener('keydown',keydown);document.removeEventListener('keyup',keyup);};
}
